import * as React from 'react';
import { ActivityDefinition } from '../../../model/activities';
import { Grid, Typography } from '@material-ui/core';
import { Star } from '@material-ui/icons';

interface IProps {
    activity: ActivityDefinition;
    onSelected: (id: string) => void;
    delete: (id: string) => void;
    confirm: (id: string) => void;
    navigateTo: (path: string) => void;
    isSelected: boolean;
    classes: any;
    key: string;
}
export const ActivityDefinitionListItem = (props: IProps) => {
    const { activity } = props;
    return <Grid container sm={12}
        className={props.isSelected ? props.classes.listItemContainerSelected : props.classes.listItemContainer}
        key={props.key}>
        <Grid container sm={12} onClick={() => props.onSelected(activity._id)} className={props.classes.listItemContainerFields}>
            <Grid item xs={2}>
                <div className={props.classes.listItemIcon}>
                    {activity.tag ? <Star fontSize='large' fill={activity.tag.color}></Star> : <></>}
                </div>
            </Grid>
            <Grid item xs={3}>
                <Typography>{activity?.displayName}</Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography>{activity?.description}</Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography>Inizio: {activity?.validFrom?.toLocaleDateString()}</Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography>Fine: {activity?.expiresOn?.toLocaleDateString()}</Typography>
            </Grid>
        </Grid>
    </Grid>
}